import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFadeIn16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFadeIn16"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#FadeIn16)">
                    <path
                        fill="currentColor"
                        d="M8.684.895q.076 0 .145.018a7.13 7.13 0 0 1 6.336 7.084l-.01.367a7.13 7.13 0 0 1-6.305 6.714.6.6 0 0 1-.166.027.6.6 0 0 1-.6-.6V1.496a.6.6 0 0 1 .6-.6m-2.42.35a.6.6 0 0 1 .6.599v12.31a.6.6 0 0 1-1.2 0V1.844a.6.6 0 0 1 .6-.6m3.02 12.547a5.93 5.93 0 0 0 4.68-5.795 5.93 5.93 0 0 0-4.68-5.795zM3.851 2.526a.6.6 0 0 1 .6.6v9.748a.6.6 0 1 1-1.2 0V3.126a.6.6 0 0 1 .6-.6M1.436 4.702a.6.6 0 0 1 .6.6v5.393a.6.6 0 1 1-1.2 0V5.302a.6.6 0 0 1 .6-.6"
                    />
                </g>
                <defs>
                    <clipPath id="FadeIn16">
                        <path fill="#fff" d="M0 0h16v16H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconFadeIn16);
